import { NodeCell, ElementPropertyConfig, FarrisPropConfigWithData } from "@edp-pmf/grapheditor";
import { MxGraphNS, mxResources } from "@edp-pmf/mxgraph-ts";
import { AifCreationBillActivity } from "@gsp-wf/wf-process-model";
import { BpmnModelHelper, FlowNodeState } from "@edp-pmf/bpmn-model";
import { WfConstants } from "../WfConstants";
import { AifCreationBillActivityPropertyKeys } from "./property-keys/AifCreationBillActivityPropertyKeys";

/**
 * 自动生单活动节点
 */
export class AifCreationBillActivityCell extends NodeCell {
    clrTypeId: string = AifCreationBillActivityCell.CLR_TYPE_ID;
    name: string = "自动生单";
    nameLanguage: { [lang: string]: string; } = {
      "zh-CHS": "自动生单",
      "zh-CHT": "自動生單",
      "en": "Creation Bill ",
  };
    static CLR_TYPE_ID: string = AifCreationBillActivity.Clr_Type_ID;
    flowElement: AifCreationBillActivity;

    imgUrls = {
        [FlowNodeState.Default]: WfConstants.IMAGE_PATH + "/aifCreationActivity.png",
        [FlowNodeState.Selected]: WfConstants.IMAGE_PATH + "/aifCreationActivity_select.svg",
    };

    constructor(value?: any, geometry?: MxGraphNS.mxGeometry, style?: string) {
        super(value, geometry, style);
    }

    createFlowElement(flowElt?: AifCreationBillActivity): AifCreationBillActivity {
        const flowNode = super.createFlowElement(flowElt) as AifCreationBillActivity;
        flowNode.Id = "AifCreationBillActivity" + BpmnModelHelper.GenerateElementId();
        return flowNode;
    }

    getFarrisPropConfig(): FarrisPropConfigWithData {
        let act = this.flowElement;

        let PropertyConfig: ElementPropertyConfig = new ElementPropertyConfig();
        let propertyData: any = new Object();
        PropertyConfig.categoryId = 'general';
        PropertyConfig.categoryName = mxResources.get('basicInformation');
        PropertyConfig.tabId = 'basic';
        PropertyConfig.tabName = mxResources.get('basicAttributes');
        PropertyConfig.properties = [
            { propertyID: AifCreationBillActivityPropertyKeys.Name, propertyName: mxResources.get('name'), propertyType: 'string', visible: !this.editorUi.multiLangEnabled },
            { propertyID: AifCreationBillActivityPropertyKeys.NameLanguage, propertyName: mxResources.get('nameLanguage'), propertyType: 'multiLanguage', visible: this.editorUi.multiLangEnabled },
            { propertyID: AifCreationBillActivityPropertyKeys.Id, propertyName: mxResources.get('id'), propertyType: 'string', readonly: true }
        ];

        let bifDef = new ElementPropertyConfig();
        bifDef.categoryId = 'bifDef';
        bifDef.categoryName = mxResources.get('bifDef');
        bifDef.tabId = 'basic';
        bifDef.tabName = mxResources.get('basicAttributes')
        bifDef.properties = [
            { propertyID: AifCreationBillActivityPropertyKeys.aifProcessCode, propertyName: mxResources.get('aifProcess'), propertyType: 'modal' },
            // { propertyID: AifCreationBillActivityResourceKeys.isRelied, propertyName: '后续依赖', propertyType: 'boolean' },
        ];

        propertyData[AifCreationBillActivityPropertyKeys.Id] = act.Id;
        propertyData[AifCreationBillActivityPropertyKeys.ClrTypeID] = act.ClrTypeID;

        propertyData[AifCreationBillActivityPropertyKeys.Name] = act.Name || mxResources.get('autoAif');
        propertyData[AifCreationBillActivityPropertyKeys.NameLanguage] = act.NameLanguage || {
            "zh-CHS": act.Name,
        };
        propertyData[AifCreationBillActivityPropertyKeys.aifProcessCode] = act.aifProcessCode
        propertyData[AifCreationBillActivityPropertyKeys.isRelied] = act.isRelied

        return {
            propertyConfig: [PropertyConfig, bifDef],
            propertyData: propertyData
        }
    }

    updateProps(obj: any) {
        const propertyId: string = obj.propertyID;
        switch (propertyId) {
            case AifCreationBillActivityPropertyKeys.aifProcessCode:
                this.resetProcessCode(this.flowElement, obj);
                break;
            default:
                super.updateProps(obj);
                break;
        }
    }

    resetProcessCode(startActivity: AifCreationBillActivity, obj: any) {
        const data = obj.propertyValue;
        if (data) {
            startActivity.aifProcessCode = data;
        } else {
            startActivity.aifProcessCode = null;
        }
    }
}
